import { Container } from '@design-system/container';
import {
  CountryPicker,
  CountryPickerProps,
} from '@design-system/country-picker';
import React, { forwardRef } from 'react';

const CountryPickerBlock = forwardRef<HTMLDivElement, CountryPickerProps>(
  (countryPicker, ref) => (
    <Container maxWidth="full-width" ref={ref}>
      <CountryPicker {...countryPicker} />
    </Container>
  )
);

export default CountryPickerBlock;
